import InternshipIcon from "../../../images/homepage/internship.png";
import MentorshipIcon from "../../../images/homepage/mentorship.png";
import SupportIcon from "../../../images/homepage/support.png";
import CertifiedIcon from "../../../images/homepage/certified.png";
import SkilledIcon from "../../../images/homepage/skilled.png";

const aboutContentData = [
  {
    icon: InternshipIcon,
    title: "Internship",
    para: "Explore and choose from a diverse selection of our internship programs  designed for skill development.",
  },
  {
    icon: MentorshipIcon,
    title: "Dedicated mentorship",
    para: "Our mentors are established industry experts who bring years of experience & valuable insight.",
  },
  {
    icon: SupportIcon,
    title: "Placement Support",
    para: "Students who advanced our internship program will get placement support from our team to get you start in the industry.",
  },
  {
    icon: CertifiedIcon,
    title: "Get certified",
    para: "We provide pro certification after the course completion. Valued by all the industries out there.",
  },
  {
    icon: SkilledIcon,
    title: "Get Skilled",
    para: "Learn from the courses of experience professionals over the internet available for free and get skilled.",
  },
];

export default aboutContentData;
